import script from "./RxNote.vue?vue&type=script&setup=true&lang=js"
export * from "./RxNote.vue?vue&type=script&setup=true&lang=js"

import "./RxNote.vue?vue&type=style&index=0&id=120a4a08&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120a4a08"]])

export default __exports__